<template>
	<div>
		<div v-if="!orderDetailsStore.order" class="tw-flex tw-items-center tw-gap-2">
			<AppSkeleton type="text" width="150px" />
			<AppSkeleton width="24px" height="24px" class="tw-rounded-lg" />
		</div>
		<div class="tw-flex tw-items-center tw-gap-2" v-else>
			<div class="tw-text-3xl tw-font-bold tw-text-black">
				{{ $t('orders.order') }} #{{ orderDetailsStore.order.order_number }}
			</div>
			<img
				:src="orderDetailsStore.order.marketplace?.logo_url"
				height="24px"
				style="height: 24px"
			/>
		</div>
	</div>
</template>

<script setup>
import AppSkeleton from '@/v2/components/skeleton.vue';

import { useOrderDetailsStore } from '../../../stores/order-details';

const orderDetailsStore = useOrderDetailsStore();
</script>

<style lang="scss" scoped></style>
